import i18next from 'i18next';

import { LocalStorageKeys } from '@shared/consts/localStorageKeys';

const getUserLanguage = () => {
  return localStorage.getItem(LocalStorageKeys.LANGUAGE);
};

const setUserLanguage = (language: string) => {
  localStorage.setItem(LocalStorageKeys.LANGUAGE, language);
};

const resolveActiveAppLanguage = (userLanguage: string | null, defaultLanguage: string) => {
  return userLanguage ? userLanguage : defaultLanguage;
};

// Plain (non-hook) read for code running outside React, e.g. axios interceptors.
// Inside components use `useUserLanguage` so they re-render on language change.
const getActiveAppLanguage = () => {
  return resolveActiveAppLanguage(getUserLanguage(), i18next.language);
};

export { getUserLanguage, setUserLanguage, resolveActiveAppLanguage, getActiveAppLanguage };
